var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","bottom":"20px","right":"20px","z-index":"1000"},attrs:{"id":"nqa-widget-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }